import styles from "./CancelFeeLotteryCompleteSection.module.scss"
import {
	CANCEL_FEE_LOTTERY_CAMPAIGN_NAME,
	CANCEL_FEE_LOTTERY_REVISIT_BOOST,
	CANCEL_FEE_LOTTERY_REVISIT_DAYS,
	CANCEL_FEE_LOTTERY_REVISIT_VISIT_DAYS,
	CANCEL_FEE_LOTTERY_WINNER_SMS_DAYS,
	CancelFeeLottery,
} from "./cancelFeeLottery"

type Props = {
	lottery: CancelFeeLottery
	cancelId: string
}

// 支払い完了画面の抽選セクション.
// 支払い期日内のお支払いでくじ券の応募が成立した時だけ、サーバが lottery を返してくる.
//
// 請求画面のバナー (CancelFeeLotteryBanner) は支払い前に応募を後押しするためのもので、
// 支払い後のここでは「応募が完了したこと」と「次の行動 (再予約して来店) で当選確率が上がること」
// だけを伝える. 見た目は再予約の完了画面の抽選セクション (LotteryEmailSection) に揃えている.
// ルーレットは出さない (倍率は請求時にくじ券へ保存済みで、回しても回さなくても応募内容は同じ).
const CancelFeeLotteryCompleteSection = ({ lottery, cancelId }: Props) => {
	const revisitMultiplier =
		lottery.multiplier * CANCEL_FEE_LOTTERY_REVISIT_BOOST

	return (
		<div className={styles.section}>
			<div className={styles.head}>
				<span className={styles.badge}>応募完了</span>
				<p className={styles.title}>{CANCEL_FEE_LOTTERY_CAMPAIGN_NAME}</p>
			</div>

			<div className={`${styles.box} ${styles.boxApplied}`} role="status">
				<p className={styles.label}>✓ 抽選への応募が完了しました</p>
				<p className={styles.value}>
					当選確率
					<span className={styles.number}>{lottery.multiplier}</span>倍
				</p>
			</div>

			<div className={styles.box}>
				<p className={styles.label}>
					{CANCEL_FEE_LOTTERY_REVISIT_DAYS}日以内に<strong>再予約</strong>して
					{CANCEL_FEE_LOTTERY_REVISIT_VISIT_DAYS}日以内に
					<strong>ご来店</strong>で
					<br />
					当選確率がさらに{CANCEL_FEE_LOTTERY_REVISIT_BOOST}倍
				</p>
				{/* 「何日から数えるのか」が分かるよう、起算日 (お支払い日) を小さく添える */}
				{lottery.paidDate !== null && (
					<p className={styles.paidDate}>お支払い日: {lottery.paidDate}</p>
				)}
				<p className={styles.value}>
					<span className={styles.number}>{lottery.multiplier}</span>倍 →
					<span className={styles.number}>{revisitMultiplier}</span>倍
				</p>
			</div>

			<ul className={styles.notes}>
				<li>
					抽選番号: <span className={styles.notesNumber}>{cancelId}</span>
				</li>
				<li>
					当選されたお客様へは、お支払い後{CANCEL_FEE_LOTTERY_WINNER_SMS_DAYS}
					日以内にSMSにてご連絡いたします。
				</li>
			</ul>
		</div>
	)
}

export default CancelFeeLotteryCompleteSection
